import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoDialog from "../../factories/bao-dialog";

/*
 * Dialog used to set up the relationship of the Field entity with the ShiftbookTab (bypass)
 * */
class ShiftbookTabFieldDialog {
    Bao = Bao;
    Dialog: BaoDialog;
    public Model: any;

    SelectedField = ko.observable();
    FieldId: KnockoutObservable<string> = ko.observable("");
    FieldKey: KnockoutObservable<string> = ko.observable("");
    FieldTypeId: KnockoutObservable<string> = ko.observable("");
    FieldName: KnockoutObservable<string> = ko.observable("");
    UseForStartDate: KnockoutObservable<boolean> = ko.observable(false);
    UseForEndDate: KnockoutObservable<boolean> = ko.observable(false);
    UseForDateVisible: KnockoutObservable<boolean> = ko.observable(false);
    IsHidden: KnockoutObservable<boolean> = ko.observable(false);
    IsBypassBook: KnockoutObservable<boolean> = ko.observable(false);
    DisplayIsHidden: KnockoutObservable<boolean> = ko.observable(false);

    constructor(data: any, dialog: BaoDialog) {
        this.Dialog = dialog;
        this.IsBypassBook(ko.unwrap(data.Parent.IsBypassBook));
        $.extend(this, data);
        data.Parent.ItemCompleteCheck = this.ItemCompleteCheck;
        if (this.FieldTypeId()) {
            this.DisplayIsHidden(true);
            this.UseForDateVisible(this.IsDateTimeFieldType(this.FieldTypeId()));
        }
        this.SelectedField.subscribe((f: any) => {

            this.ResetFieldDetail();
            let fieldIsDate: boolean = false;
            if (f != null) {
                this.FieldId(f.FieldId);
                this.FieldKey(f.MatchCode);
                this.FieldName(f.FieldName);
                fieldIsDate = this.IsDateTimeFieldType(f.FieldTypeId);
                this.FieldTypeId(f.FieldTypeId);
                this.DisplayIsHidden(true);
            } else {
                this.FieldId(null);
                this.FieldKey(null);
                this.FieldName(null);
                this.DisplayIsHidden(false);
                this.FieldTypeId("");
            }

            this.UseForDateVisible(fieldIsDate);
        });

    }
    ResetFieldDetail = () => {
        this.IsHidden(false);
        this.UseForEndDate(false);
        this.UseForStartDate(false);
    }
    ItemCompleteCheck = (item: any): JQueryPromise<boolean> => {
        let def = $.Deferred<boolean>();
        let result = true;

        if (Bao.Utils.String.IsNullOrWhitespace(this.FieldName())) {
            result = false;
        }

        if (!result) {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        def.resolve(result);
        return def.promise();
    }

    /*
     * Checks whether the passed value is a id for a DateTime FieldType
     * */
    private IsDateTimeFieldType(guid: string): boolean {
        if (guid) {
            return guid.toLocaleLowerCase() === '1590b9a9-8c51-4acf-9b8a-91b53447f37b';
        }
        return false;
    }

}
export default ShiftbookTabFieldDialog;